import React, { useEffect, useState, useContext } from 'react'
import Button from '../formfields/Button'
import { GlobalContext } from '../GlobalContext'
import Card from '../ui-elements/Card'
import GreenAlert from '../ui-elements/GreenAlert'
import ProgressBar from '../ui-elements/ProgressBar'
import RedAlert from '../ui-elements/RedAlert'
import { padOutZeros } from '../utils/padOutZeros'
import SummaryCheckWindow from './SummaryCheckWindow'
import { getChecklistProgress } from '../utils/getChecklistProgress'
import YellowAlert from '../ui-elements/YellowAlert'
import { useNavigate } from 'react-router-dom'
import Modal from '../ui-elements/Modal'
import ChecklistStatus from './ChecklistStatus'
import { sortAllQuestionAnswersForCheckPeriod } from '../utils/sortAllQuestionAnswersForCheckPeriod'
import { findNextQuestionUrl } from '../utils/findNextQuestionUrl'
import DeleteButton from '../formfields/DeleteButton'
import FormatQuestionTitle from './FormatQuestionTitle'
import FormatChecklistTitle from './FormatChecklistTitle'
import { subscribe } from '../utils/pubsub'
import { removeNonAlphanumeric } from '../utils/removeNonAlphanumeric'
import ChecklistCategoryNames from './ChecklistCategoryNames'
import JsonDebug from '../ui-elements/JsonDebug'
import { checkIfCheckPeriodIsLocked } from '../utils/checkIfCheckPeriodIsLocked'
import FormatCheckPeriodStartedBy from './FormatCheckPeriodStartedBy'
import FormatCheckPeriodTimeRange from './FormatCheckPeriodTimeRange'
import FormatCheckPeriodInProgress from './FormatCheckPeriodInProgress'

type Props = {
  checklistId: string
  thisChecklist: ObjectStringKeyAnyValue
  // isChecklistActive: boolean
  checkPeriodId?: string
}

function ChecklistSummary({
  checklistId,
  thisChecklist,
  // isChecklistActive,
  checkPeriodId
}: Props) {

  const {
    t,
    isRTL,
    tableData,
    isSignoffRequired,
    sendMessageToWebsocket,
    fetchAssetById,
    setShowModal,
    userData,
    loggedIn
  } = useContext(GlobalContext)

  const navigate = useNavigate()
  const [checklistProgress, setChecklistProgress] = useState<null | ObjectStringKeyAnyValue>(null)
  const [check_period_start, set_check_period_start] = useState<ObjectStringKeyAnyValue | null>(null)
  const [check_period_end, set_check_period_end] = useState<ObjectStringKeyAnyValue | null>(null)
  const [active_check_period, set_active_check_period] = useState<ObjectStringKeyAnyValue | null>(null)
  const [numberOfAlerts, setNumberOfAlerts] = useState(0)
  const [thisCheckPeriodSignoff, setThisCheckPeriodSignoff] = useState<ObjectStringKeyAnyValue | null>(null)

  const [startQuestionUrl, setStartQuestionUrl] = useState<string | null>(null)
  const thisChecklistPeriod = checkPeriodId && tableData && tableData.ChecklistPeriods && tableData.ChecklistPeriods[checkPeriodId]
  // let titleText = thisChecklist && thisChecklist['ChecklistName'] ? thisChecklist['ChecklistName'] : 'Checklist'
  // let assetId = ''
  const cssId = thisChecklist && thisChecklist['ChecklistName'] && removeNonAlphanumeric(thisChecklist['ChecklistName'])


  const isCheckPeriodLocked = checkIfCheckPeriodIsLocked(thisChecklistPeriod, thisChecklist, userData, loggedIn)


  useEffect(() => {

    if (checkPeriodId && tableData) {

      if (thisChecklistPeriod && thisChecklistPeriod.Progress) {
        const nextStepUrl = findNextQuestionUrl(null, checkPeriodId, tableData)
        setStartQuestionUrl(nextStepUrl)
      }



      if (thisChecklistPeriod) {

        setThisCheckPeriodSignoff(thisChecklistPeriod['Signoff'])
        set_active_check_period(thisChecklistPeriod)
        set_check_period_end(thisChecklistPeriod['EndHoursMins'])
        set_check_period_start(thisChecklistPeriod['StartHoursMinsDay'])

        if (thisChecklistPeriod['AssetId']) {
          fetchAssetById(thisChecklistPeriod['AssetId'])
        }

        if (thisChecklistPeriod['AnswerAlerts']) {
          let newNumberOfAlerts = 0
          for (const actionToTake in thisChecklistPeriod['AnswerAlerts']) {
            if (actionToTake !== 'followUpQuestion') {
              newNumberOfAlerts = newNumberOfAlerts + thisChecklistPeriod['AnswerAlerts'][actionToTake].length
            }
          }
          setNumberOfAlerts(newNumberOfAlerts)
        }
      }
    }
  }, [tableData, checkPeriodId, checklistId])







  if (!thisChecklist) {
    console.error(`Checklist data not found for check period id: ${checkPeriodId}`)
    return null
  }

  return <div className={`w-full`}>
    <Card fullwidth={true} id={cssId}>
      <div className={`w-full flex flex-col justify-between gap-2 
        ${isRTL ? ' text-right items-end ' : ''}`}>

        {/* <p>Check period:{checkPeriodId}</p>
        <p>Checklist: {checklistId}</p>  */}

        {/* <JsonDebug jsonobject={thisChecklistPeriod}  /> */}

        <FormatChecklistTitle
          thisChecklistPeriod={thisChecklistPeriod}
          thisChecklist={thisChecklist}
          classString={`text-lg font-righteous text-brandblue`}
        />

        {thisChecklistPeriod && <FormatCheckPeriodTimeRange
          thisChecklistPeriod={thisChecklistPeriod}
          thisChecklist={thisChecklist}
        />}

        <ChecklistCategoryNames
          checklistData={thisChecklist}
          showIfNone={false}
        />



        {thisChecklist && thisChecklist['Schedule'] &&
          thisChecklist['Schedule']['Frequency'] &&
          thisChecklist['Schedule']['Frequency'] !== 'ADHOC' &&
          (!thisChecklist['Schedule']['CheckWindows'] || Object.keys(thisChecklist['Schedule']['CheckWindows']).length === 0) &&
          <RedAlert icon={true} alignment={'left'}>{t('Dashboard.ChecklistSummary.noCheckTimes')}</RedAlert>}


        {thisChecklistPeriod && thisChecklistPeriod.Progress &&
          <p>
            {t('Dashboard.ChecklistSummary.numberOfQuestionsCompleted', {
              completed: thisChecklistPeriod.Progress.completed_answers,
              total: thisChecklistPeriod.Progress.total_answers
            })}</p>}

        {thisChecklistPeriod && thisChecklistPeriod.Progress && thisChecklistPeriod.Progress.total_answers && thisChecklistPeriod.Progress.total_answers > 0 && thisChecklistPeriod.Progress.progress_percentage < 100 ?
          <ProgressBar
            percentage={thisChecklistPeriod.Progress.progress_percentage}
          /> : ''}

        <div className={`flex flex-row gap-1 flex-wrap`}>





          <ChecklistStatus
            checkPeriodId={checkPeriodId}
            checklistProgress={thisChecklistPeriod && thisChecklistPeriod.Progress}
            thisCheckPeriodSignoff={thisCheckPeriodSignoff}
            thisChecklistPeriod={thisChecklistPeriod}
            thisChecklist={thisChecklist}
          />

          {numberOfAlerts > 0 &&
            <RedAlert icon={true} alignment={`left`} fullwidth={true}>
                {t('Dashboard.ChecklistSummary.alertsRaised', {count: numberOfAlerts })}
            </RedAlert>}


        </div>

        {/* <p>[{startQuestionId}]</p> */}

        {thisChecklistPeriod && <FormatCheckPeriodStartedBy
          thisChecklistPeriod={thisChecklistPeriod}
          thisChecklist={thisChecklist}
        />}



        {thisChecklist &&
          <div className={`w-full flex flex-col sm:flex-row gap-2`}>

            {
              checkPeriodId && <Button
                internalLinkUrl={`/checklists/${checkPeriodId}`}
                text={t('Dashboard.ChecklistSummary.allQuestions')}
                variant={`primary`}
                fullwidth={true}
              //size={'big'}
              />
            }

            {
              checkPeriodId &&
              !isCheckPeriodLocked &&
              startQuestionUrl &&
              startQuestionUrl !== 'AllQuestionsComplete' &&
              thisChecklistPeriod &&
              thisChecklistPeriod.Progress &&
              <Button
                internalLinkUrl={startQuestionUrl}
                text={`${thisChecklistPeriod.Progress.progress_percentage}` === `0` ?
                t('Dashboard.ChecklistSummary.startChecklist') :
                t('Dashboard.ChecklistSummary.continueChecklist')}
                variant={`primary`}
                fullwidth={true}
              //size={'big'}
              />}





            {
              checkPeriodId &&
              !isCheckPeriodLocked && isSignoffRequired && !thisCheckPeriodSignoff && checklistProgress && (checklistProgress.numberOfExpectedAnswers === checklistProgress.numberOfCompletedAnswers) &&
              <Button
                internalLinkUrl={`/checklists/${checkPeriodId}/complete-checklist`}
                text={t("Dashboard.ChecklistSummary.signOffChecklist")}
                variant={`primary`}
                fullwidth={true}
              //size={'big'}
              />}


            {
              !isCheckPeriodLocked &&
              thisChecklist.Schedule &&
              thisChecklist.Schedule.Frequency &&
              thisChecklist.Schedule.Frequency === 'ADHOC' &&
              !checkPeriodId &&
              <Button
                internalLinkUrl={`/start-checklist/${thisChecklist['Id']}`}
                text={t("Dashboard.ChecklistSummary.startAdhocChecklist")}
                variant={`primary`}
                fullwidth={true}
                id={`startAdhocChecklist`}
              //size={'big'}
              />}


          </div>}

      </div>
    </Card>



  </div>
}

export default ChecklistSummary

